import { PostSortRowsParams } from 'ag-grid-community';

export const postSortFullWidthGroups = (params: PostSortRowsParams<any>) => {
  params.nodes = params.nodes.sort((a, b) => a.data.groupIndex - b.data.groupIndex);
};
